import { render } from "./EnableOtp.vue?vue&type=template&id=af8c8bd0"
import script from "./EnableOtp.vue?vue&type=script&lang=js"
export * from "./EnableOtp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__